import { render } from "./InitialHoldDetailsCard.vue?vue&type=template&id=6e964bd0&scoped=true&ts=true&lang=pug"
import script from "./InitialHoldDetailsCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./InitialHoldDetailsCard.vue?vue&type=script&lang=ts&setup=true"

import "./InitialHoldDetailsCard.vue?vue&type=style&index=0&id=6e964bd0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e964bd0"]])

export default __exports__